import Vue from 'vue';
import VueRouter, { NavigationGuard, } from 'vue-router';
import { multiGuard, } from '~/utils/vue-router-multiguard';
import Index from './pages/index.vue';
import { Store, } from './store';

Vue.use(VueRouter);

const prefix = '/pay-bill';
const RequiresUserDetails: NavigationGuard = (to, _from, next) => {
	if (to.path === prefix) {
		next();
		return;
	}

	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	if (!Store.getters.hasExistingUserDetails) {
		next('/');
		return;
	}

	next();
};

const RequiresUserPaymentDetails: NavigationGuard = (_to, _from, next) => {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	if (!Store.getters.hasExistingUserPaymentDetails) {
		next('/');
		return;
	}
	next();
};

export const Router = new VueRouter({
	base: prefix,
	mode: 'history',
	scrollBehavior() {
		return { x: 0, y: 0, };
	},
	routes: [
		{
			path: '/',
			component: {
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				render: (c: any) => c('router-view'),
			},
			children: [
				{ path: `your-details`, component: () => import('./pages/your-details.vue').then((m) => m.default), },
				{ path: `check-details`, component: () => import('./pages/check-details.vue').then((m) => m.default), beforeEnter: multiGuard([RequiresUserDetails, RequiresUserPaymentDetails,]), },
				{ path: `choose-amount`, component: () => import('./pages/choose-amount.vue').then((m) => m.default), beforeEnter: multiGuard([RequiresUserDetails, RequiresUserPaymentDetails,]), },
				{ path: `payment`, component: () => import('./pages/payment-detail.vue').then((m) => m.default), beforeEnter: multiGuard([RequiresUserDetails, RequiresUserPaymentDetails,]), },
				{ path: `success`, component: () => import('./pages/payment-success.vue').then((m) => m.default), beforeEnter: RequiresUserDetails, },
				{ path: `error/payment`, component: () => import('./pages/payment-failure.vue').then((m) => m.default), beforeEnter: RequiresUserDetails, },
				{ path: `error/system`, component: () => import('./pages/system-failure.vue').then((m) => m.default), beforeEnter: RequiresUserDetails, },
				{ path: `pending`, component: () => import('./pages/payment-pending.vue').then((m) => m.default), beforeEnter: RequiresUserDetails, },
				{ path: ``, component: Index, },
			],
		},
	],
});

Router.afterEach((to) => {
	Store.commit.setActiveAlert(to.fullPath);
});
